'use client';
import Image from 'next/image';
import Link from 'next/link';
import SpeakerSectionNew from './NewSpeakers2025';

const upcomingEvents = [

  {
    name: "empowher-in-ai-singapore-2026",
    src: "/images/empowher-in-ai-singapore-2026.webp",
    link: "https://luma.com/xittin7u",
  },
  
  // {
  //   name: "empowher-in-ai-riyadh",
  //   src: "/images/empowher-in-ai-riyadh.webp",
  //   link: "https://luma.com/herstoryinairiyadh2026",
  // },
  {
    name: "empowher-abudhabi2026",
    src: "/images/empowher-abudhabi2026.webp",
    link: "https://luma.com/empowherin_ai?k=c",
  },
];

const pastEvents = [
  {
    name: "HerStory-in-AI-Abu-Dhabi",
    src: "/images/empowher-abudhabi-luma.webp",
    link: "https://lu.ma/herstoryinaiabudhabi",
  },
  {
    name: "event-img",
    src: "/images/event-img.webp",
    link: "https://lu.ma/hh3owgnq",
  },
  {
    name: "EmpowHER-Women-Dubai-2024",
    src: "/images/empowher-women-dubai-2024.webp",
    link: "https://luma.com/oos61xp6?tk=GGJYd7",
  },
  
 
  
];

const EventsSection = () => {
  return (
    <section id="events" className="w-full relative pt-[60px] pb-[60px]"
    style={{
          backgroundImage: "url('/images/bg-abstract-n.webp')", 
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
      {/* Background Image */}
      {/* <div className="absolute inset-0 w-full h-full">
        <Image
          src="/images/bg-abstract-n.webp"
          alt="Background Element"
          width={1200}
          height={600}
          className="object-cover object-right"
          priority
        />
      </div> */}

      {/* Upcoming Events */}
      <div className="relative w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-2 ">
        <div className="flex flex-col gap-8 lg:gap-[54px] justify-start items-center w-full lg:w-[92%] mx-auto">
          {/* Section Title */}
          <div className="w-full">
            <h2 className="text-[24px] sm:text-[30px] lg:text-4xl font-extrabold leading-[28px] sm:leading-[34px] lg:leading-5xl text-center text-text-darkest">
              Upcoming Events
            </h2>
          </div>

          {/* Events Grid */}
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-[1px] w-full justify-center place-items-center">

          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-[32px] w-full"> */}
            {upcomingEvents.map((event, index) => (
              <Link key={index} href={event.link} target="_blank" rel="noopener noreferrer nofollow">
                <Image
                  src={event.src}
                  alt={event.name}
                  width={364}
                  height={344}
                  className="w-[500px] h-[130px] sm:h-[300px] lg:h-[500px] rounded-2xl object-cover transition-transform duration-200 hover:scale-105"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* <SpeakerSectionNew /> */}

     {/* Past Events */}
      <div className="relative w-full max-w-[1140px] mx-auto pt-[30px]">
        <div className="flex flex-col gap-8 lg:gap-[54px] justify-start items-center w-full lg:w-[100%] mx-auto">
          {/* Section Title */}
          <div className="w-full">
            <h2 className="text-[24px] sm:text-[30px] lg:text-4xl font-extrabold leading-[28px] sm:leading-[34px] lg:leading-5xl text-center text-text-darkest">
              Past Events
            </h2>
          </div>

          {/* Events Grid */}
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-[32px] w-full px-4 bg-transparent">

          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-[32px] w-full justify-center place-items-center"> */}
            {pastEvents.map((event, index) => (
              <Link key={index} href={event.link} target="_blank" rel="noopener noreferrer nofollow">
                <Image
                  src={event.src}
                  alt={event.name}
                  width={364}
                  height={344}
                  className="w-[450px] h-[130px] sm:h-[300px] lg:h-[340px] rounded-2xl object-cover transition-transform duration-200 hover:scale-105 border-2 border-pink-200"
                  unoptimized
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
